var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaison(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.882,
    height: 12.604,
    viewBox: "0 0 13.882 12.604",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_136",
    "data-name": "Rectangle 136",
    width: 13.882,
    height: 12.604,
    fill: "#0d0b0e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2582",
    "data-name": "Groupe 2582",
    transform: "translate(0 -0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2581",
    "data-name": "Groupe 2581",
    transform: "translate(0 0.004)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_902",
    "data-name": "Trac\\xE9 902",
    d: "M371.758,2058.9a.55.55,0,0,0-.549.55v4.737h-2.941v-2.514a.55.55,0,0,0-.55-.55H365.09a.55.55,0,0,0-.55.55v2.574h-2.986v-5.158a.55.55,0,1,0-1.1,0v5.708a.551.551,0,0,0,.55.55h4.085a.551.551,0,0,0,.55-.55v-2.575h1.53v2.515a.55.55,0,0,0,.548.55h4.04a.55.55,0,0,0,.55-.55v-5.287a.55.55,0,0,0-.55-.55",
    transform: "translate(-359.441 -2052.744)",
    fill: "#0d0b0e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_903",
    "data-name": "Trac\\xE9 903",
    d: "M13.679,5.324,7.264.128A.548.548,0,0,0,6.579.122h0L.21,5.14A.549.549,0,1,0,.89,6L6.913,1.257l6.073,4.92a.55.55,0,0,0,.692-.854",
    transform: "translate(0 -0.005)",
    fill: "#0d0b0e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaison);
export default __webpack_public_path__ + "static/media/maison.b020a46f402a0d0a301c6f5bb2feb381.svg";
export { ForwardRef as ReactComponent };